import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { accessPermitRelationTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { restore } from "sources/books/accessPermits";

export class AccessPermits extends BookIndex {
    get tableColumns() {
        const restoreAction = (id) => {
            this.props.modal({
                name: "confirm",
                title: "Вы действительно хотите восстановить?",
                action: () => restore({ id }).then(() => this.props.mergeParams({})),
                buttons: { confirm: "Да", cancel: "Нет" },
            });
        };

        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.adminAccessPermitsShow(id)}>{value}</Link>,
            },
            {
                Header: "Тип допуска",
                accessor: "relationType",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "status" },
                            options: accessPermitRelationTypes,
                        }}
                    />
                ),
                Cell: ({ value }) => enumLabel(accessPermitRelationTypes, value),
                CSVExport: ({ value }) => enumLabel(accessPermitRelationTypes, value),
            },
            isDeletedColumn(restoreAction, true),
        ];
    }

    renderCreateButton = () => {
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.adminAccessPermitsNew,
        };
        return <Link {...props}>{this.props.createBtnText}</Link>;
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(AccessPermits, "admin-access-permits");
